<template>
  <div style="height:calc(100% - 8px);width:100%;">
    <iframe :src="src" width="100%" height="100%" frameborder="0"  scrolling="no">

    </iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      src: 'https://cn28fc437k.coze.site',
    };
  },
  created() {
    // this.src = `${dcwjUrl}?token=${this.$store.state.token}`;
  },
  mounted() {},
};
</script>

<style lang="less">
.scrollbar{
    height: 100%;
}
</style>
